<template>
  <div class="qw-layout">
    <Navbar />
    <div class="qw-layout__page">
      <AppMain />
    </div>
  </div>
</template>

<script>
// 页面骨架：fixed 顶部导航（qw-navbar）+ 内容区（qw-layout__page / qw-layout-main）
// 导航高度留白、页面 flex 撑满等布局由 styles/navbar-business.scss 与 business-page-theme.scss 接管
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'

export default {
    name: 'Layout',
    components: { AppMain, Navbar }
}
</script>

<style lang="scss" scoped>
.qw-layout {
    min-height: 100vh;
    background: var(--qw-bg-page);
}
</style>
